// The blue bar with the title of a section (CHECKLIST, FOTO KENDARAAN).
const EditorSectionHeader = ({ title }) => {
  return (
    <div className="elevated-card-tight-vertical !px-4 !py-3 !bg-indigo-300 row-between-center w-full">
      <span className="text-sm font-bold text-slate-700">{title}</span>
    </div>
  );
};

export default EditorSectionHeader;
